//@vendor
const moment = require('moment');
//@constants
const { DATE_FORMAT_API, BROKER_LAST_MIFID_DAY } = require('constants/index');

function nationalIdDateValidation(lastAccessDate) {  //Set in false when using in moreOptionsButton
    const formattedLastAccessDate = moment(lastAccessDate, DATE_FORMAT_API);
    const lastMiFIDDay = moment(BROKER_LAST_MIFID_DAY);
    return (formattedLastAccessDate > lastMiFIDDay)
}

module.exports = {
    nationalIdDateValidation
};
